// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/role.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / actions / custom-tabs).

import type { DetailPageConfig } from "../../components/composition/DetailPage";
import { rolesApi } from "../../api/roles";
import type { Role } from "../../api/types";
// override-block:imports BEGIN
// override-block:imports END

// override-block:helpers BEGIN
// override-block:helpers END

export const roleDetailConfig: DetailPageConfig<Role> = {
  idParam: "id",
  queryKey: (id: string) => ["roles", "detail", id] as const,
  queryFn: (id: string) => rolesApi.getRole(id),
  backTo: "/roles",
  // override-block:title BEGIN
  title: (r) => r.display_name,
  // override-block:title END
  // override-block:subtitle BEGIN
  subtitle: (r) => r.slug ?? null,
  // override-block:subtitle END
  statusCards: (r, _fmt) => [
    // override-block:statcard-type BEGIN
    {
      // is_system is boolean — StatCardDef.value accepts string|number,
      // so we project to "system"/"custom" at the slot (per the
      // team-member-detail mfa pattern).
      id: "type",
      label: "Type",
      value: r.is_system ? "system" : "custom",
      format: "text",
      tone: "g-people",
    },
    // override-block:statcard-type END
    {
      id: "priority",
      label: "Priority",
      value: r.priority,
      format: "number",
      tone: "g-home",
    },
    {
      id: "permissions",
      label: "Permissions",
      value: r.permission_count,
      format: "number",
      tone: "g-giving",
    },
    {
      id: "users",
      label: "Users",
      value: r.user_count,
      format: "number",
      tone: "g-people",
    },
  ],
  actions: (_r) => [
    // override-block:actions BEGIN
    // override-block:actions END
  ],
  tabs: [
    // override-block:custom-tabs BEGIN
    // override-block:custom-tabs END
  ],
};
